import { getPropsFromNode, nodeMatches } from '../utils'
import DropCap from '../../components/atom/DropCap'
import { h } from '../parser/utils'

export const NAME = 'drop-cap'

export const COMPONENTS = {
  DropCap,
}

export function matches(node) {
  return nodeMatches(node, 'p.has-drop-cap')
}

export async function transform(node, next, ctx) {
  const children = await next(node.childNodes, ctx)
  const props = getPropsFromNode(node)

  return h(DropCap, props, ...children)
}

